// Bulk-import is a documented raw-axios exception (CLAUDE.md, audit Section 6) —
// the upload uses `AxiosProgressEvent` which RTK Query's base query doesn't
// expose. File-scope disable for the wire-shape `any`s until the exception
// changes.
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

import { getAPIUrls } from '../../../../util/env';
import type {
  OrderErrorFormData,
  PropertyErrorFormData
} from '../../../../types/property.types';

export const updateBulkListAPI = (
  formValues: PropertyErrorFormData[]
): Promise<any> => {
  const API_URL: string = getAPIUrls(
    '/property-service/api/v1/properties/bulk/list'
  );
  return axios.post(`${API_URL}`, formValues);
};

export const updateBulkListForOrderAPI = (
  formValues: OrderErrorFormData[]
): Promise<any> => {
  const API_URL: string = getAPIUrls(
    '/order-service/api/v1/orders/bulkupload/fix'
  );
  return axios.post(`${API_URL}`, formValues);
};

export const getFileFailureDataAPI = (
  fileId: string,
  isProperty: boolean
): Promise<any> => {
  let API_URL: string;
  if (isProperty) {
    API_URL = getAPIUrls('/property-service/api/v1/properties/bulk/requests');
  } else {
    API_URL = getAPIUrls('/order-service/api/v1/orders/bulk/requests');
  }
  return axios.get(`${API_URL}/${fileId}`);
};

export const downloadBulkOrderTemplateAPI = (): Promise<any> => {
  const API_URL: string = getAPIUrls(
    '/order-service/api/v1/orders/bulk/template'
  );
  return axios.get(API_URL, { responseType: 'blob' });
};

export const downloadBulkPropertyTemplateAPI = (): Promise<any> => {
  const API_URL: string = getAPIUrls(
    '/property-service/api/v1/properties/bulk/template'
  );
  return axios.get(API_URL, { responseType: 'blob' });
};
